<div class="container-503">
	<div class="box">
		
		<div class="box-header">
			<div class="title-group">
				<div class="title-text">
					<div class="error-text">Error 503</div>
					<div class="main-title">Este servicio no está disponible</div>
				</div>

				<div class="subtitle">
					El servicio al que intentas acceder no está disponible por el momento. 
					Intenta actualizar la página o volver a la pantalla principal.
				</div>
			</div>

			<div class="button-group">
				<app-button 
					buttonClass="btn-md-secondary-full" 
					label="Actualizar" 
					(click)="goBack()">
				</app-button>

				<app-button 
					buttonClass="btn-md-primary-full" 
					label="Ir a la pantalla principal" 
					(click)="continueHome()">
				</app-button>
			</div>
		</div>

		<div class="box-footer"></div>

	</div>
</div>
